"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./TransferHistoryComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var transferHistoryClasses = (0, _cssClassesHelper.getBEMClasses)('transfer-history');
var TransferHistoryComponent = function TransferHistoryComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var transfers = props.transfers,
    fetching = props.fetching;
  if (fetching) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: transferHistoryClasses('spinner')
    }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
      isInline: true
    }));
  } else if (transfers.length === 0 && !fetching) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: transferHistoryClasses('item')
    }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
      name: "stop",
      customClass: transferHistoryClasses('icon')
    }), t("No Transfer History"));
  } else {
    return transfers.map(function (userName, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        className: transferHistoryClasses('item')
      }, userName);
    });
  }
};
var _default = exports["default"] = TransferHistoryComponent;